import { Action, combineReducers, configureStore } from "@reduxjs/toolkit";
import thunk, { ThunkMiddleware } from "redux-thunk";
import { ISendumSupportState, SendumSupportReducer } from "./SendumSupportReducer";

const SendumSupportRootReducer = combineReducers({
	SendumSupport: SendumSupportReducer,
});

export type SendumSupportRootState = ReturnType<typeof SendumSupportRootReducer>;


export interface DispatchAction extends Action {
	payload: Partial<ISendumSupportState>;
}

const middleware = thunk as ThunkMiddleware<SendumSupportRootState, DispatchAction>;

export const sendumSupportStore = configureStore({
	reducer: SendumSupportRootReducer,
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware().concat(middleware),
});
